<script setup lang="ts">
    import { topBannerText } from '@/plugins/featureFlags/showTopBanner';
</script>

<template>
    <div class="banner-container">
        <h4 class="text-white font-weight-regular pa-2 pl-12">
            <v-icon class="font-size-small mb-0" size="large">mdi-information-outline</v-icon>
            {{ topBannerText() }}
        </h4>
    </div>
</template>

<style lang="scss" scoped>
    @use '../../styles/global/variables';

    .banner-container {
        background-color: rgb(var(--v-theme-red));
        top: 0;
        left: 0;
        width: calc(100% + 0px);

        display: block;
        height: variables.$app-top-banner-height !important;

        :deep(div) {
            height: variables.$app-top-banner-height !important;
        }

        :deep(div) {
            display: flex;
            align-items: center;
        }
    }

    .banner-icon {
        display: inline-block;
        vertical-align: middle;
        margin-right: 20px;
    }
</style>
